export default __webpack_public_path__ + "static/media/credit-card.f0ce3f70.svg";